/** @jsx jsx */
import { jsx } from 'theme-ui'
import React from 'react'
import ImgixImg from './index'

import { path } from '../../../utils/obj'
import { useEntity } from '../selectors'

const ImgixImgConnected = ({ entity, ...props }) => {
  const { description, file, ...imageProps } = useEntity(entity)
  const aspectRatio = file?.details && file.details.image.height / file.details.image.width
  const width = props.width
  const height = props.height || (width && aspectRatio && width * aspectRatio)

  return (
    <ImgixImg
      {...props}
      {...imageProps}
      alt={description || imageProps.title}
      src={path(['url'], file)}
      width={width}
      height={height}
      sx={{ height: 'auto' }}
      aspectRatio={aspectRatio}
    />
  )
}

export default ImgixImgConnected
